<button
    mat-icon-button
    type="button"
    id="fab-grid-config"
    class="se-button-config menu-config"
    [ngClass]="{ small: sizeConfiguration === 'small', white: confColor === 'white' }"
    matTooltipPosition="above"
    matTooltip="{{ settingsTooltip | translate }}"
    [matMenuTriggerFor]="gridConfigMenu"
>
    <mat-icon>settings</mat-icon>
</button>
<mat-menu #gridConfigMenu="matMenu" yPosition="above" xPosition="before" class="test-menu">
    <div class="se-mat-menu">
        <button
            *ngFor="let btn of extraButtons"
            mat-menu-item
            class="se-menu-item se-menu-button"
            [matMenuTriggerFor]="btn.triggerFor"
        >
            {{ btn.label | translate }}
        </button>
        <ng-content select="[before]"></ng-content>
        <ng-container *ngFor="let menuConfig of settingsConfig; index as idx">
            <se-settings-menu
                (settingChanged)="handleSubMenuEvent($event, menuConfig.menuName)"
                [menuDataValues]="settingsDataValuesList[idx]"
                [menuName]="menuConfig.menuName"
                [nameTranslationKey]="menuConfig.nameTranslationKey"
                [menuSettings]="menuConfig.settings"
            ></se-settings-menu>
        </ng-container>
        <ng-content select="[after]"></ng-content>
        <button
            (click)="showSaveSettingsSite && onSaveSettings(settingType.site)"
            *ngIf="isCurrentUserAuthorized()"
            class="se-menu-item se-menu-button"
            mat-menu-item
        >
            {{ "SaveCurrentVisualizationForSite" | translate }}
        </button>
        <button
            (click)="showResetDefaultSettingsSite && onResetDefaultSettings(settingType.site)"
            *ngIf="isCurrentUserAuthorized()"
            class="se-menu-item se-menu-button"
            mat-menu-item
        >
            {{ "ReloadDefaultVisualizationForSite" | translate }}
        </button>
        <button
            (click)="showSaveSettingsUser && onSaveSettings(settingType.user)"
            class="se-menu-item se-menu-button"
            mat-menu-item
        >
            {{ "SaveCurrentVisualizationForUser" | translate }}
        </button>
        <button
            (click)="showResetDefaultSettingsUser && onResetDefaultSettings(settingType.user)"
            class="se-menu-item se-menu-button"
            mat-menu-item
        >
            {{ "ReloadDefaultVisualizationForUser" | translate }}
        </button>
    </div>
</mat-menu>
